<template>
  <div class="project-camera-info">
    <el-form ref="form" :model="form" :rules="rules" label-position="top">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入名称"></el-input>
      </el-form-item>
      <el-form-item label="分辨率" prop="resolution">
        <el-select v-model="form.resolution" placeholder="请选择类型">
          <el-option v-for="(value, index) in resolutionOptions" :key="index" :label="value" :value="value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="地址" prop="address">
        <el-input v-model="form.address" placeholder="请输入地址"></el-input>
      </el-form-item>
      <el-form-item label="位置" prop="position">
        <el-input v-model="form.position" placeholder="请输入位置"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import ProjectService from '@/io/project.js';

  export default {
    name: 'ProjectCameraInfo',
    props: {
      deviceId: {
        type: Number,
        default: null
      },
      cameraId: {
        type: Number,
        default: null
      }
    },
    watch: {
      cameraId: {
        handler(newValue, oldValue) {
          this.initOptions().then(() => {
            if (newValue) {
              this.initDatas();
            }
          }).catch(() => {});
        },
        immediate: true
      }
    },
    data() {
      return {
        id: this.$route.params.id,
        form: {
          name: '',
          resolution: '',
          address: '',
          position: ''
        },
        rules: {
          name: [
            {
              required: true, message: '请输入名称'
            }
          ],
          resolution: [
            {
              required: true, message: '请选择分辨率'
            }
          ],
          address: [
            {
              required: true, message: '请输入地址'
            }
          ],
          position: [
            {
              required: true, message: '请输入位置'
            }
          ],
        },
        resolutionOptions: []
      }
    },
    methods: {
      initOptions() {
        return ProjectService.cameraResolutionParam().then(res => {
          this.resolutionOptions = res.data.map(val => {
            return `${val.width}*${val.height}`;
          });
          this.form.resolution = this.resolutionOptions[0];
        }).catch(() => {});
      },
      initDatas() {
        ProjectService.deviceInfo(this.id, this.cameraId).then(res => {
          this.form.name = res.data.device_name;
          this.form.resolution = `${res.data.device_attr_data.device_camera_attr_resolution_width}*${res.data.device_attr_data.device_camera_attr_resolution_height}`;
          this.form.address = res.data.device_attr_data.device_camera_attr_stream_url;
          this.form.position = res.data.device_attr_data.device_camera_attr_location;
        }).catch(() => {})
      },
      submit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            if (this.cameraId) {
              ProjectService.editCamera(
                this.id,
                this.cameraId,
                this.form.name,
                this.form.resolution.split('*')[0],
                this.form.resolution.split('*')[1],
                this.form.address,
                this.form.position
              ).then(() => {
                this.$message.success('编辑成功');
                this.$emit('cancel');
                this.$emit('submit');
              }).catch(() => {});
            } else {
              ProjectService.addCamera(
                this.id,
                this.deviceId,
                this.form.name,
                this.form.resolution.split('*')[0],
                this.form.resolution.split('*')[1],
                this.form.address,
                this.form.position
              ).then(() => {
                this.$message.success('创建成功');
                this.$emit('cancel');
                this.$emit('submit');
              }).catch(() => {});
            }
          }
        });
      },
      cancel() {
        this.$emit('cancel');
      }
    },
  }
</script>

<style lang="less" scoped>
  .project-camera-info {
    /deep/ .el-form {
      .el-form-item {
        .el-form-item__content {
          text-align: center;
        }
      }
    }
  }
</style>